import Provider from "./hooks"

export default function checkOTP() {
  return (
    <>
      <Provider />
    </>
  )
}
